import { cn } from '@commander/ui';
import type React from 'react';
import type { FormInputProps } from '../../types/onboarding.types';

const FormInput: React.FC<FormInputProps> = ({
  label,
  type,
  value,
  onChange,
  error,
  hint,
  placeholder,
  required,
  disabled,
  helperText,
  className,
}) => {
  const baseInputClassName = cn(
    'w-full max-w-[508px] text-body-text-large text-[#737982] font-paragraph',
    'border border-border-gray rounded-[4px] focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-200',
    'px-4 py-2',
    disabled && 'bg-gray-100 cursor-not-allowed',
    error && 'border-red-500 focus:border-red-500 focus:ring-red-500',
    className
  );

  const labelClassName = cn(
    'text-heading-4 font-paragraph text-[#737982] block mb-2',
    required && "after:content-['*'] after:ml-1 after:text-red-500"
  );

  const errorClassName = 'text-sm text-red-500 mt-1';
  const helperTextClassName = 'text-sm text-gray-600 mt-1';

  return (
    <div className="space-y-2">
      <label htmlFor={label} className={labelClassName}>
        {label}
      </label>

      {type === 'textarea' ? (
        <textarea
          id={label}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          disabled={disabled}
          className={cn(baseInputClassName, 'min-h-[100px] resize-none')}
          rows={4}
        />
      ) : (
        <input
          id={label}
          type={type}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          disabled={disabled}
          className={baseInputClassName}
          {...(type === 'url' && {
            inputMode: 'url',
            pattern: 'https?://.*',
          })}
        />
      )}

      {error && <p className={errorClassName}>{error}</p>}

      {hint && !error && <p className="text-sm text-amber-600 mt-1">{hint}</p>}

      {helperText && !error && !hint && <p className={helperTextClassName}>{helperText}</p>}
    </div>
  );
};

export default FormInput;
